/* Important Info component acc page */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/Account.module.css";

const InfoCon = () => {
  return (
    <div className="mb-5 px-3">
        <Row className="my-3">
        <Col md={{span: 10, offset: 1}}>
        <div className={`px-3 py-2 ${styles.SubTitle6 }`}>
          <h5 className={`${styles.Blue} text-center`}>CONTACT INFO</h5>
          <hr className={`mt-2 mb-0`}/>

          <p className={`pt-1`}>
          <span className={`${styles.Blue}`}>*</span> Contact us with regard to non-Service
          Desk issues.
          </p>
          <p className={`pt-1`}>
          <span className={`${styles.Blue}`}>*</span> This form may also be used along with the Service Desk for urgent technical
          issues if necessary.
          </p>
          <hr className={`mt-2 mb-0`}/>
         </div> 
        </Col>
      </Row>
    </div>
  )
}

export default InfoCon